
import { makeStyles } from '@material-ui/core/styles';

// eslint-disable-next-line import/prefer-default-export
export const useStyles = makeStyles(() => ({
  gridList: {
    flexWrap: 'nowrap',
    overflow: 'auto',
  },
  root: {
    width: '100%',
  },
  containerImage: {
    display: 'flex',
    position: 'inherit',
    margin: '10px',
    width: '350px',
    // minWidth: '18rem',
    '& > img': {
      width: '-webkit-fill-available',
      height: '300px'
    },
  },
  cardBodyList: {
    minWidth: '300px',
    margin: 'auto',
  },
  buttonOnImage: {
    position: 'absolute',
    top: '86%',
    left: '86%',
  },
  center: {
    flexGrow: 1,
    margin: '10px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));
